import {FiLock} from "react-icons/fi";

import {FormLabel} from "@/components/form/FormLabel.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {Input} from "@/components/input/Input.tsx";
import {InputGroup} from "@/components/inputGroup/InputGroup.tsx";
import {Select} from "@/components/select/Select.tsx";
import {LockedDropdownIndicator} from "@/components/select/subComponents/DropdownIndicator/DropdownIndicator.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {
  findIntervalOption,
  intervalOptionByMinute,
  intervalValueDisplay,
} from "@/pages/checks/components/form/fields/interval/utils.ts";

interface IntervalReadOnlyFieldProps {
  className?: string;
  value: number;
  name: string;
  lockedTooltip?: string;
}

export const IntervalReadOnlyField = ({className, name, value, lockedTooltip}: IntervalReadOnlyFieldProps) => {
  const innerValue = intervalValueDisplay(value, intervalOptionByMinute(value));
  const selectedIntervalType = findIntervalOption(value);
  return (
    <div className={className}>
      <FormLabel forId="name" required>
        Check Interval
      </FormLabel>
      <div className="d-flex gap-3">
        <div className="pulseMaxWidthXXS">
          <Tooltip tooltipContent={lockedTooltip} onModal>
            <div aria-label="Locked field">
              <InputGroup endElement={<Icon icon={FiLock} />} disabled>
                <Input name={name} value={innerValue} />
              </InputGroup>
            </div>
          </Tooltip>
        </div>
        <div className="pulseMaxWidthXS flex-grow-1">
          <Tooltip tooltipContent={lockedTooltip} onModal>
            <div aria-label="Locked field">
              <Select
                value={selectedIntervalType}
                isDisabled
                components={{DropdownIndicator: LockedDropdownIndicator, IndicatorSeparator: () => null}}
              />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
